export default "assets/images/7d9d643a903df6f57b8b7386316021e5.png";